<script>
	export let id = null;
	export let name = null;
	export let label = null;
	export let sublabel = null;
	export let value = null;
	export let maxlength = null;
	export let placeholder = null;
	export let rows = 3;
	export let required = null;
	export let disabled = null;
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}

	</label>
{/if}
<textarea
	{required}
	{disabled}
	{id}
	{name}
	{maxlength}
	{rows}
	{placeholder}
	bind:value
	class="form-control"
/>

<style>

	textarea {
		height: auto;
	}

</style>